export default __webpack_public_path__ + "static/rule-1-e5feb5bd975d2d97f6cee738dc75e4f1.svg";